import React from 'react'
import PropTypes from 'prop-types'

import { LoadingWave } from '../../../components'
import { sleep } from '../../../utils'

export default class Verify extends React.Component {
  static propTypes = {
    navigate: PropTypes.func,
    onVerify: PropTypes.func.isRequired,
    verify: PropTypes.func.isRequired,
  }

  _verify = async () => {
    try {
      await Promise.all([
        this.props.verify(),
        sleep(1500), // to let the user read the changes
      ])
      this.props.onVerify()
    } catch (error) {
      console.error(error)
      this.props.navigate('../error')
    }
  }

  componentDidMount() {
    this._verify()
  }

  render() {
    return (
      <div className="maxw-600px mx-auto text-center">
        <h4>Verifying authorization...</h4>
        <LoadingWave />
      </div>
    )
  }
}
